import {doApi} from "./core";

export function getCoupons(language, params) {
    return doApi(language, params, "/account/get_coupons")
}

export function registration(language, params) {
    return doApi(language, params, "/account/registration")
}

export function login(language, params) {
    return doApi(language, params, "/account/login")
}

export function passwordRecover(language, params) {
    return doApi(language, params, "/account/password_recover")
}

export function getSummary(language, params) {
    return doApi(language, params, "/account/get_summary");
}

export function updateCustomer(language, params) {
    return doApi(language, params, "/account/update");
}

export function getDeliveryAddresses(language, params) {
    return doApi(language, params, "/account/get_delivery_addresses");
}

export function setDefaultDeliveryAddress(language, params) {
    return doApi(language, params, "/account/set_default_delivery_address");
}

export function deleteDeliveryAddress(language, params) {
    return doApi(language, params, "/account/delete_delivery_address");
}

export function newDeliveryAddress(language, params) {
    return doApi(language, params, "/account/new_delivery_address");
}

export function getOrderHistory(language, params) {
    return doApi(language, params, "/account/get_order_history");
}

export function getOrder(language, params) {
    return doApi(language, params, "/account/get_order");
}

export function getReserveHistory(language, params) {
    return doApi(language, params, "/account/get_reserve_history");
}

export function getMessaging(language, params) {
    return doApi(language, params, "/account/get_messaging");
}

export function getChat(language, params) {
    return doApi(language, params, "/account/chat/get");
}

export function sendChatMessage(language, params) {
    return doApi(language, params, "/account/chat/send_message");
}

export function markChatMessages(language, params) {
    return doApi(language, params, "/account/chat/mark_messages");
}

export function status(language, params) {
    return doApi(language, params, "/account/status");
}

export function sendFirebaseToken(language, params) {
    return doApi(language, params, "/account/set_firebase_token");
}

export function logout(language, params) {
    return doApi(language, params, "/account/logout");
}

export function reserve(language, params) {
    return doApi(language, params, "/account/reserve");
}

export function stripeGetClientSecret(language, params) {
    return doApi(language, params, "/account/pay/stripe/get-client-secret");
}

export function stripeNotifyConfirmation(language, params) {
    return doApi(language, params, "/account/pay/stripe/notify-confirmation");
}

export function cartCheck(language, params) {
    return doApi(language, params, "/account/cart-check");
}

export function addToBlockingList(language, params) {
    return doApi(language, params, "/account/add_to_blocking_list");
}

export function getBillingAddress(language, params) {
    return doApi(language, params, "/account/get_billing_address");
}

export function newBillingAddress(language, params) {
    return doApi(language, params, "/account/new_billing_address");
}

export function getFidelityCardRewards(language, params) {
    return doApi(language, params, "/account/get_fidelity_card_rewards");
}

export function order(language, params) {
    return doApi(language, params, "/account/order");
}

export function getPredefinedAddress(language, params) {
    return doApi(language, params, "/account/get-indirizzo-predefinito");
}

export function stripeGetPaymentMethods(language, params) {
    return doApi(language, params, '/account/pay/stripe/get-payment-methods');
}

export function stripeDetachPaymentMethod(language, params) {
    return doApi(language, params, '/account/pay/stripe/detach-payment-method');
}

export function stripeGetSetupIntentClientSecret(language, params) {
    return doApi(language, params, '/account/pay/stripe/get-setup-intent-client-secret');
}

export function paypalGetClientToken(language, params) {
    return doApi(language, params, '/account/pay/paypal/get-client-token');
}

export function paypalExecuteTransaction(language, params) {
    return doApi(language, params, '/account/pay/paypal/execute-transaction');
}
